export const AUTH_SIGNIN_LOADING = "auth/signin/loading";
export const AUTH_SIGNIN_ERROR = "auth/signin/error";
export const AUTH_SIGNIN_SUCCESS = "auth/signin/success";

export const AUTH_SIGNUP_LOADING = "auth/signup/loading";
export const AUTH_SIGNUP_ERROR = "auth/signup/error";
export const AUTH_SIGNUP_SUCCESS = "auth/signup/success";

export const AUTH_SIGNOUT = "auth/signout";